import { render, staticRenderFns } from "./DjBranches.vue?vue&type=template&id=2a78722c&scoped=true&lang=pug&"
import script from "./DjBranches.vue?vue&type=script&lang=ts&"
export * from "./DjBranches.vue?vue&type=script&lang=ts&"
import style0 from "./DjBranches.vue?vue&type=style&index=0&id=2a78722c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a78722c",
  null
  
)

component.options.__file = "DjBranches.vue"
export default component.exports